<template>
  <div id="app">
    <div class="bg"></div>
    <div class="links" v-if="$route.name !== 'index'">
      <a href="https://www.ctbutterfield.com/contact" rel="noreferrer" target="_blank">
        <font-awesome-icon icon="life-ring" />
        <span>Get</span> help
      </a>
      <a href="https://www.ctbutterfield.com/" rel="noreferrer" target="_blank">
        <font-awesome-icon icon="external-link-alt" />
        <span>Return to</span> main website
      </a>
    </div>

    <header class="header" v-if="$route.name !== 'index'">
      <router-link to="/">
        <img alt="Memorial configurator" class="logo" src="/images/butterfields.png" />
      </router-link>
    </header>
    <router-view :key="$route.fullPath" />
    <footer class="footer">
      <div class="left">
        Built by
        <a href="https://chameleoncreative.marketing" rel="noreferrer" target="_blank">Chameleon Creative</a>
      </div>
      <div class="right">
        <a href="https://www.ctbutterfield.com/privacy-policy" rel="noreferrer" target="_blank">Privacy Policy</a>
        &copy; CT Butterfields &amp; Sons
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("getText")
    this.$store.dispatch("getColours")
    this.$store.dispatch("getExtras")
    this.$store.dispatch("getExamples")
    this.$store.dispatch("getSizes")
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto Slab:wght@400;900&family=Open+Sans&display=swap");
@import "https://fonts.googleapis.com/css?family=Roboto+Slab:400,700";

@font-face {
  font-family: "Zaph Chancery Demi";
  src: 
    /* Safari, Android, iOS */ url("/ck/fonts/itc_zapf_chancery_demi_regular-webfont.woff") format("woff"),
    /* Modern Browsers */ url("/ck/fonts/itc_zapf_chancery_demi_regular-webfont.woff2") format("woff2"); /* Modern Browsers */
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Goudy Old Style Bold";
  src: 
    /* Safari, Android, iOS */ url("/ck/fonts/goudosb-webfont.woff") format("woff"),
    /* Modern Browsers */ url("/ck/fonts/goudosb-webfont.woff2") format("woff2"); /* Modern Browsers */
  font-weight: normal;
  font-style: normal;
}

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

*:focus {
  outline: none !important;
}

.slicknav_menu {
  display: none;
}

a {
  color: inherit;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
}

img {
  max-width: 100%;
}

html,
body {
  padding: 0;
  margin: 0;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  overflow-x: hidden;
}

body {
  box-sizing: border-box;
  line-height: 1.8;
  padding-bottom: 5rem;
  min-height: 100.1vh;
}

html {
  font-size: 62.5%;
}

.bg {
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 100vh;
  box-shadow: inset 0px 0px 3.4rem 0px rgba(0, 0, 0, 0.18);
}

body,
input,
select,
textarea {
  font-family: "Open Sans", sans-serif;
  font-size: 2rem;
}

h1,
h2 {
  font-size: 3.5rem;
  color: #b1ba22;
  font-family: "Roboto Slab", serif;
  line-height: 1.2;
  padding: 1rem 0;

  padding-top: 1.5rem;
}

h2 {
  font-size: 2.5rem;
}

h1::after {
  display: block;
  content: " ";
  height: 1px;
  width: 15rem;
  background: #e7e7e7;
  margin: 3rem auto;
}

p {
  margin: 1rem 0;
}

.footer {
  position: fixed;
  bottom: 2rem;
  left: 2%;
  width: 96%;
  font-size: 1.3rem;
  color: rgb(194, 194, 194);
  z-index: 3;
  pointer-events: none;
}

.footer .left {
  float: left;
  pointer-events: all;
}
.footer .right {
  float: right;
  pointer-events: all;
}
.footer .left a {
  color: rgb(168, 168, 168);
}
.footer a:hover {
  color: #b1ba22;
}

.links {
  position: fixed;
  animation: slidein 2s;
  right: 2%;
  background: #e3e8e8;
  color: #666;
  padding: 0.5rem 1.5rem;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  font-size: 1.5rem;
  z-index: 3;
}

.links a {
  padding: 0 1rem;
}

.links svg {
  color: #b1ba22;
  margin-right: 0.5rem;
}

.header {
  position: fixed;
  padding-top: 2.5rem;
  left: 2%;
  z-index: 3;
  animation: slidein 1.5s;
}

.logo {
  width: 20rem;
}

.panel {
  width: 90%;
  left: 5%;
  position: absolute;
  z-index: 2;
  padding-top: 15rem;
  padding-bottom: 10rem;
}

.fading {
  animation: fadein 0.5s;
}

.nofade {
  animation: none !important;
}

.options {
  font-family: "Roboto Slab", serif;
  color: #b1ba22;
}

.actions button {
  background: #b1ba22;
  font-family: "Roboto Slab", serif;
  border: 0;
  padding: 1rem 2rem;
  color: white;
  font-size: 2.5rem;
  cursor: pointer;
  border-bottom: 0;
  transition: all 0.4s;
  border-radius: 0.5rem;
}
.actions button:hover {
  padding: 1rem 2.5rem;
}
.actions button.back {
  background: #8fa1a1;
}
.actions {
  padding-top: 3rem;
}
.pulse {
  margin-bottom: -0.3rem;
}

p a {
  border-bottom: 1px solid #b1ba22;
}

/* Customize the label (the container) */
.radio-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 1.8rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 2px;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 50%;
  transition: all 0.3s;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked ~ .checkmark {
  background-color: #b1ba22;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  transition: all 0.3s;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.radio-container .checkmark:after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}

.checkbox {
  width: 100%;
  margin: 15px auto;
  position: relative;
  display: block;
}

.checkbox input[type="checkbox"] {
  width: auto;
  opacity: 0.00000001;
  position: absolute;
  left: 0;
  margin-left: -20px;
}
.checkbox label {
  position: relative;
}
.checkbox label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  margin: 4px;
  width: 22px;
  height: 22px;
  transition: transform 0.28s ease;
  border-radius: 3px;
  border: 2px solid #006654;
}
.checkbox label:after {
  content: "";
  display: block;
  width: 10px;
  height: 5px;
  border-bottom: 2px solid #006654;
  border-left: 2px solid #006654;
  -webkit-transform: rotate(-45deg) scale(0);
  transform: rotate(-45deg) scale(0);
  transition: transform ease 0.25s;
  will-change: transform;
  position: absolute;
  top: 12px;
  left: 10px;
}
.checkbox input[type="checkbox"]:checked ~ label::before {
  color: #e6b23b;
}

.checkbox input[type="checkbox"]:checked ~ label::after {
  -webkit-transform: rotate(-45deg) scale(1);
  transform: rotate(-45deg) scale(1);
}

.checkbox label {
  min-height: 34px;
  display: block;
  padding-left: 40px;
  margin-bottom: 0;
  font-weight: normal;
  cursor: pointer;
  vertical-align: sub;
  font-size: 1.5rem;
}
.checkbox label span {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.checkbox input[type="checkbox"]:focus + label::before {
  outline: 0;
}

.v--modal-overlay {
  background: rgba(0, 0, 0, 0.7) !important;
}

.v--modal-overlay .v--modal-box {
  max-width: 1000px !important;
  margin: auto;
  left: auto !important;
  padding: 3rem;
}

.modal-close {
  color: #ed2229;
  width: 3rem;
  height: 3rem;
  font-size: 3rem;
  display: block;
  position: absolute;
  right: 1rem;
  top: 0rem;
  text-align: center;
  transition: all 0.2s;
}
.modal-close:hover {
  transform: scale(1.1);
}

.v--modal p {
  font-size: 1.5rem;
}

.controls {
  text-align: center;
  color: #666;
  font-size: 2.5rem;
}

.controls a {
  margin: 0 1rem;
}
.controls a svg {
  transition: all 0.3s;
}

.controls a:hover svg {
  transform: scale(1.1);
  color: #006654;
}

.inscription {
  height: 44rem;
}
.heart .inscription {
  height: 30rem;
}

.cke {
  border-radius: 0.25rem;
}

.error {
  color: #ed2229;
  padding-bottom: 2rem;
}

@keyframes fadein {
  0% {
    opacity: 0;
    top: 0;
  }
  50% {
    opacity: 0;
    top: 0;
  }
  100% {
    opacity: 1;
    top: 0;
  }
}

@media screen and (max-width: 1400px) {
  html {
    font-size: 50%;
  }
  .pulse {
    transform: scale(0.6);
    margin-bottom: -1.1rem;
  }
}
@media screen and (max-width: 750px) {
  .links a span {
    display: none;
  }
  .links a {
    text-transform: capitalize;
  }
  .links {
    z-index: 4;
    background: transparent;
    padding-top: 1rem;
  }
  .footer {
    background: white;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 1rem 5%;
    box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.15);
  }

  .header {
    background: white;
    left: 0;
    top: 0;
    padding: 1rem 5%;
    padding-bottom: 0;
    width: 100%;
    box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.15);
  }
}

@keyframes slidein {
  0% {
    top: -15rem;
  }
  50% {
    top: -15rem;
  }
  100% {
    top: 0;
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.15s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

@media screen and (max-width: 440px) {
  .links a {
    display: block;
    text-align: right;
    margin-right: 0;
    padding-right: 0;
  }
  .panel {
    padding-bottom: 10rem;
    padding-top: 10rem;
  }
  .footer .left,
  .footer .right {
    float: none;
    text-align: center;
  }
  .header {
    padding-bottom: 0;
  }
}
</style>
